import adminConfig from '@/features/promotions/config.json';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { computed } from 'vue';
import { toValue, type MaybeRefOrGetter } from '@vueuse/core';
import type { TitleDetail } from '@/interfaces/title-details-graphql';
import { useSingleQTV } from '@/features/buybox/composables/useSingleQTV';
import { useTitleDetailsStore } from '@/stores/pinia/useTitleDetailsStore';

// Curated list of JustWatch Originals eligible for JWTV Utopia SQTV experiment
export const JWTV_UTOPIA_TITLES = [
	'tm1297462',
	'tm1340687',
	'tm947073',
	'tm1070741',
	'tm1108302',
	'tm1002998',
	'tm1048003',
	'tm860017',
	'tm991773',
	'tm817928',
	'tm72644',
	'tm464088',
	'tm1521030',
];

export const JWTV_UTOPIA_SHORTNAME = 'jwt';

// Minimum similarity score for a SQTV result to be considered valid for JWTV Utopia
export const jwtvSimilarityThreshold = adminConfig.steering_overrides_global.jwtv_utopia_sqtv_similarity_threshold;

export function useJWTVUtopia(title: MaybeRefOrGetter<TitleDetail>, enabled: MaybeRefOrGetter<boolean> = true) {
	const { country } = storeToRefs(useLanguageStore());
	const { inLists } = storeToRefs(useTitleDetailsStore());

	const _title = computed(() => toValue(title));
	const isJWTVUtopiaEnabled = computed(
		() =>
			country.value === 'IT' &&
			inLists.value.includes('EXP_LOWPERF_IT_200626') &&
			adminConfig.steering_overrides_global.jwtv_utopia_sqtv_italy &&
			!_title.value.offers.some(o => o.package.shortName === JWTV_UTOPIA_SHORTNAME) &&
			toValue(enabled)
	);
	const { isSQTVEmpty } = useSingleQTV(_title, JWTV_UTOPIA_SHORTNAME, isJWTVUtopiaEnabled);
	// false when flag is off, country is not IT, or SQTV found no result above the similarity threshold
	const isJWTVUtopiaActive = computed(() => isJWTVUtopiaEnabled.value && !isSQTVEmpty.value);
	return { isJWTVUtopiaActive };
}
